// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {AuthGuard} from '@quantum-theme/core/guards/auth.guard';

const routes: Routes = [
	{path: '', redirectTo: 'quantum', pathMatch: 'full'},
  {path: 'auth', loadChildren: 'app/auth/auth.module#AuthModule'},
  {
    path: 'quantum',
    canActivate: [AuthGuard],
    loadChildren: 'app/quantum-theme/views/themes/quantum/theme.module#ThemeModule'
  },
  {path: 'share', loadChildren: 'app/share-inspection/share-inspection.module#ShareInspectionModule'},
	{path: 'screen-dashboard', loadChildren: 'app/screen-dashboard/screen-dashboard.module#LargeScreenDashboardModule'},
  {path: '**', redirectTo: 'quantum/error/403', pathMatch: 'full'},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes)
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
